export default "__VITE_ASSET__6cd05f76__"